@if (!!headerMessage) {
	<div class="message-header">
		<div class="text-header-container">
			<mat-icon class="info-icon" svgIcon="info"></mat-icon>
			<p class="m-0 text-accent-darker header-text"><b>{{ headerMessage }}</b></p>
		</div>
		<mat-icon class="pointer close-header-icon" (click)="close()">close</mat-icon>
	</div>
}
